import axios from 'axios'
import store from "./store"
import qs from "query-string";

const apiClient = axios.create({
  baseURL: process.env.VUE_APP_API_SERVER_BASE_URL,
  xsrfHeaderName: "X-CSRFToken",
  xsrfCookieName: "csrftoken",
  paramsSerializer: (params) => {
    return qs.stringify(params, { arrayFormat: 'repeat' });
  }
});
const externalClient = axios.create({
});

export const get = (url, params = {}, token, success, failed, silent) => {
  return request(url, "get", {params}, token, success, failed, silent);
};

export const post = (url, data = {}, token, success, failed, silent) => {
  return request(url, "post", {data}, token, success, failed, silent);
};

export const put = (url, data = {}, token, success, failed, silent) => {
  return request(url, "put", {data}, token, success, failed, silent);
};

export const postFormData = (url, data = {}, contentType, token, success, failed, silent) => {
  return requestFormData(url, "post", {data, contentType}, token, success, failed, silent);
};

export const putFormData = (url, data = {}, contentType, token, success, failed, silent) => {
  return requestFormData(url, "put", {data, contentType}, token, success, failed, silent);
};

export const del = (url, data = {}, token, success, failed, silent) => {
  return request(url, "delete", {data}, token, success, failed, silent);
};
const request = (url, method, {params, data}, token, success, failed, silent) => {
  const headers = {};
  headers["X-Requested-With"] = 'XMLHttpRequest';
  if (token) {
    return token.then( (value) => {
      headers["Authorization"] = `Bearer ${value}`;
      return requestBase(url, method, headers, {params, data}, success, failed, silent);
    })
  }
  return requestBase(url, method, headers, {params, data}, success, failed, silent);
};

const requestFormData = (url, method, {params, data, contentType}, token, success, failed, silent) => {
  const headers = {};
  if (contentType) {
    headers["content-type"] = contentType;
  }
  if (token && url.startsWith("/")) {
    return token.then( (value) => {
      headers["Authorization"] = `Bearer ${value}`;
      return requestBase(url, method, headers, {params, data}, success, failed, silent);
    })
  }
  return requestBase(url, method, headers, {params, data}, success, failed, silent);
};

const requestBase = (url, method, headers ,{params, data}, success, failed, silent) => {
  const client = url.startsWith("/") ? apiClient : externalClient;
  return new Promise((resolve, reject) => {
    if (!silent) {
      store.dispatch("system/beginRequest");
    }
    client({
      url,
      method,
      params,
      data,
      headers,
    }).then(res => {
      if (success) {
        success(res);
      }
      resolve(res);
    }, res => {
      if (failed) {
        failed(res);
      }
      reject(res);
    }).finally( () => {
      if (!silent) {
        store.dispatch("system/endRequest");
      }
    })
  })
};
